import { render, staticRenderFns } from "./BasisForm.vue?vue&type=template&id=8d0767c2&scoped=true"
import script from "./BasisForm.vue?vue&type=script&lang=js"
export * from "./BasisForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0767c2",
  null
  
)

export default component.exports